import React, { useState } from 'react';
import './ShopSection.css';

const ShopSection = ({ addToCart }) => {
  const [filter, setFilter] = useState('All');
  const [expandedProduct, setExpandedProduct] = useState(null);

  const products = [
    { id: '1', name: 'Basmati Rice (20kg)', category: 'Groceries', image: 'https://www.healthysupplies.co.uk/pics/800x800/organic-white-basmati-rice-sussex-wholefoods-7RC06.webp', price: 28, deal: '15% Off 5+', bulkOptions: { '10kg': 16, '20kg': 28, '50kg': 60 }, isHot: true },
    { id: '2', name: 'Cola Cans (48-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/61JlTYqyYyL._AC_UL480_FMwebp_QL65_.jpg', price: 20, deal: 'Buy 2, Save £5', bulkOptions: { '24-pack': 12, '48-pack': 20, '96-pack': 38 } },
    { id: '3', name: 'Toilet Rolls (72-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/61SnIkJm7kL._AC_UL480_FMwebp_QL65_.jpg', price: 24, deal: '20% Off 10+', bulkOptions: { '36-pack': 13, '72-pack': 24, '144-pack': 45 }, isHot: true },
    { id: '4', name: 'Pasta Bulk (10kg)', category: 'Groceries', image: 'https://m.media-amazon.com/images/I/81GKjXfDsXL._AC_UL480_FMwebp_QL65_.jpg', price: 22, deal: '2-for-£40', bulkOptions: { '5kg': 13, '10kg': 22, '20kg': 40 } },
    { id: '5', name: 'Energy Drinks (24-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/61SnIkJm7kL._AC_UL480_FMwebp_QL65_.jpg', price: 24, deal: '25% Off Cases', bulkOptions: { '12-pack': 13, '24-pack': 24, '48-pack': 45 } },
    { id: '6', name: 'Bleach Bottles (12-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/71uad6OhVgL._AC_UL480_FMwebp_QL65_.jpg', price: 16, deal: 'Buy 5, Get 1 Free', bulkOptions: { '6-pack': 9, '12-pack': 16, '24-pack': 30 } },
    { id: '7', name: 'Chocolate Bars (48-pack)', category: 'Snacks', image: 'https://m.media-amazon.com/images/I/71MlQ4CXXrL._AC_UL480_FMwebp_QL65_.jpg', price: 26, deal: '30% Off Bulk', bulkOptions: { '24-pack': 15, '48-pack': 26, '96-panck': 48 }, isHot: true },
    { id: '8', name: 'Frozen Chips (10kg)', category: 'Frozen', image: 'https://m.media-amazon.com/images/I/71MlQ4CXXrL._AC_UL480_FMwebp_QL65_.jpg', price: 32, deal: '20% Off 5+', bulkOptions: { '5kg': 18, '10kg': 32, '20kg': 60 } },
    { id: '9', name: 'Soap Bars (20-pack)', category: 'Personal Care', image: 'https://m.media-amazon.com/images/I/51Ku4FMdpdL._AC_UL480_FMwebp_QL65_.jpg', price: 14, deal: '3-for-£38', bulkOptions: { '10-pack': 8, '20-pack': 14, '40-pack': 26 } },
    { id: '10', name: 'Wipes Bulk (200-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/61lBVjA7jrL._AC_UL480_FMwebp_QL65_.jpg', price: 16, deal: '30% Off 10+', bulkOptions: { '100-pack': 9, '200-pack': 16, '500-pack': 38 } },
    { id: '11', name: 'Crisps Crate (96-pack)', category: 'Snacks', image: 'https://m.media-amazon.com/images/I/815cdFlhZBL._AC_UL480_FMwebp_QL65_.jpg', price: 24, deal: '3-for-2', bulkOptions: { '48-pack': 13, '96-pack': 24, '192-pack': 45 } },
    { id: '12', name: 'Frozen Pizzas (20-pack)', category: 'Frozen', image: 'https://www.spar.co.uk/media/yryp2fvt/08abe9a4-102b-4bb1-8286-0f20f132ed89.jpg', price: 48, deal: '25% Off Bulk', bulkOptions: { '10-pack': 26, '20-pack': 48, '40-pack': 90 } },
    { id: '13', name: 'Shampoo Cases (24-pack)', category: 'Personal Care', image: 'https://m.media-amazon.com/images/I/61g4058UiJL._AC_SX679_PIbundle-24,TopRight,0,0_SH20_.jpg', price: 36, deal: '15% Off 5+', bulkOptions: { '12-pack': 20, '24-pack': 36, '48-pack': 68 } },
    { id: '14', name: 'Tea Bags (480-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/717yNTlal6L._AC_UL480_FMwebp_QL65_.jpg', price: 18, deal: 'Buy 3, Save £5', bulkOptions: { '240-pack': 10, '480-pack': 18, '960-pack': 34 } },
    { id: '15', name: 'Coffee Jars (6-pack)', category: 'Beverages', image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93', price: 30, deal: '15% Off Bulk', bulkOptions: { '3-pack': 16, '6-pack': 30, '12-pack': 55 } },
    { id: '16', name: 'Bin Bags (100-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/71V4WbI05PL._AC_UL480_FMwebp_QL65_.jpg', price: 14, deal: 'Buy 10, Save £10', bulkOptions: { '50-pack': 8, '100-pack': 14, '200-pack': 26 } },
  ];

  const categories = ['All', 'Groceries', 'Beverages', 'Household', 'Snacks', 'Frozen', 'Personal Care'];
  const filteredProducts = filter === 'All' ? products : products.filter((p) => p.category === filter);

  const toggleProduct = (id) => {
    setExpandedProduct(expandedProduct === id ? null : id);
  };

  return (
    <section className="shop-section" id="products">
      <div className="shop-container">
        <h2 className="shop-title">Nand's Bulk Shop</h2>
        <div className="shop-filter">
          {categories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? 'active' : ''}`}
              onClick={() => setFilter(category)}
              aria-pressed={filter === category}
            >
              {category}
            </button>
          ))}
        </div>
        <ul className="shop-list">
          {filteredProducts.map((product) => (
            <li key={product.id} className="shop-item">
              <button
                className="item-header"
                onClick={() => toggleProduct(product.id)}
                aria-expanded={expandedProduct === product.id}
                aria-controls={`details-${product.id}`}
              >
                <div className="item-summary">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="item-image"
                  />
                  <div className="item-info">
                    <h3 className="item-title">{product.name}</h3>
                    <p className="item-category">{product.category}</p>
                    {product.isHot && <span className="item-hot">Hot Deal!</span>}
                  </div>
                </div>
                <span className="item-toggle">
                  {expandedProduct === product.id ? '−' : '+'}
                </span>
              </button>
              <div
                id={`details-${product.id}`}
                className={`item-details ${
                  expandedProduct === product.id ? 'open' : ''
                }`}
              >
                <p className="item-deal">{product.deal}</p>
                <ul className="bulk-options">
                  {Object.entries(product.bulkOptions).map(([qty, price]) => (
                    <li key={qty} className="bulk-option">
                      <span>{qty}: £{price}</span>
                      <button
                        onClick={() => addToCart(product, qty, price)}
                        aria-label={`Add ${qty} of ${product.name} to cart`}
                      >
                        Add to Cart
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>
        <button className="cart-preview" onClick={() => alert('View cart')}>
          View Cart
        </button>
      </div>
    </section>
  );
};

export default ShopSection;